export const eventLoop = () =>
  new Promise<void>((resolve) => {
    setTimeout(() => resolve(), 0);
  });
